<template>
  <div class="intro">
    <div class="intro__innerwrap">

      <div class="intro__bg">
        <div v-if="coverImagePortrait" class="intro__bg-image intro__bg-image--portrait" v-bind:style="{ backgroundImage: 'url(' + coverImagePortrait + ')' }"></div>
        <div class="intro__bg-image" v-bind:style="{ backgroundImage: 'url(' + coverImage + ')' }"></div>
        <video class="intro__bg-video" v-if="coverVideo" :src="coverVideo" muted autoplay plays-inline></video>
      </div>
      <div class="intro__boxes">

        <div class="intro__box intro__box--top">
          <h1 class="intro__title" v-html="title"></h1>
          <p class="intro__intro" v-html="intro"></p>
        </div>

        <div v-for="block in contentBlocks" class="intro__box">
          <h2 class="intro__block-title" v-html="block.title"></h2>
          <div class="intro__block-content" v-html="block.content"></div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';

export default {
  name: 'intro',
  components: { PrevNextNav },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    intro() {
      return this.page.intro;
    },
    coverImage() {
      return this.page.coverImage;
    },
    coverImagePortrait() {
      return this.page.coverImagePortrait;
    },
    coverVideo() {
      return this.page.coverVideo;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.intro {
  @include page;
  color: $c_white;
  text-align: right;

  &__bg {
    pointer-events: none;
    width: 100%;
    overflow: hidden;
    position: relative;

    @include mobile {
      &::after {
        padding-top: 95%;
        content: '';
        display: block;
      }
    }

    @include not-mobile {
      position: fixed;
      top: 40px;
      left: 40px;
      bottom: 110px;
      width: 83.33%;
      max-height: 100%;
      transition: bottom .35s;

      .menu-show & {
        bottom: 150px;
      }
    }

    @include landscape {
      position: fixed;
      top: 20px;
      left: 20px;
      bottom: 90px;
      width: 83.33%;
      max-height: 100%;
    }
  }

  &__bg-image {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &--portrait {
      display: none;
    }

    @include portrait {
      &--portrait {
        display: block;
      }

      &--portrait + & {
        display: none;
      }
    }
  }

  &__bg-video {
    min-width: 100%; 
    min-height: 100%; 
    
    /* Setting width & height to auto prevents the browser from stretching or squishing the video */
    width: auto;
    height: auto;
    
    /* Center the video */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    transition: opacity .5s;

    &.hide {
      opacity: 0;
      pointer-events: none;
    }
  }

  &__boxes {
    display: inline-block;
    position: relative;
    z-index: 1;

    @include not-mobile {
      margin-top: 40px;
      margin-bottom: 20px;
      width: calc(41.66% - 10px);
    }

    @include landscape {
      margin-top: 20px;
      margin-bottom: 0;
      width: calc(50% - 10px);
    }

    @include not-tablet {
      width: calc(33.33% - 10px);
    }
  }

  &__box {
    display: block;
    background: $c_white;
    box-sizing: border-box;
    padding: 40px 30px 30px;
    text-align: left;
    color: $c_black;
    margin-bottom: 20px;

    @include not-tablet {
      padding: 50px 40px 40px;
    }

    &--top {
      padding: 60px 30px 50px;
      color: $c_white;
      background: $c_primary;

      @include not-mobile {
        padding: 60px 30px;
      }

      @include not-tablet {
        padding: 60px 40px;
      }
    }
  }

  &__title {
    @include font-title;

    @include not-tablet {
      width: 70%;
    }
  }

  &__intro {
    @include font-intro;
  }

  &__block-title {
    @include font-block-title;
  }

  &__block-content {
    @include font-block-content;
    margin: 2.2em 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Intro.vue